export default __webpack_public_path__ + "static/media/cityIcon.14caf25a.svg";